import {
  InternalOverlay,
  type InternalSliceData,
} from './internal/pie-chart.js';

export interface PieChartState {
  overlay: InternalOverlay;
  highlightedId: string | undefined;
  visibleSlices: InternalSliceData[];
}

export const initialState: PieChartState = {
  overlay: {
    mouseInBounds: false,
  },
  highlightedId: undefined,
  visibleSlices: [],
};
